<template lang="pug">
.bloco-dados-territorio-monitoramento-socio-ambiental
    .bloco-dados-territorio--interno
        .bloco-dados-territorio--interno--texto
            .bloco-dados-territorio-interno--titulo CAR's vinculados:
                .bloco-dados-territorio-interno--valor(
                    v-if='territorio.cars && territorio.cars.length > 3'
                )
                    p(
                        v-for='(car, index) in territorio.cars.slice(0, 3)',
                        :key='index'
                    ) {{ formatarCar(car.codigo) }}
                        el-popover(
                            v-if='index === 2',
                            placement='bottom',
                            trigger='hover'
                        )
                            el-tag.ml-2(
                                v-if='territorio.cars.length > 1',
                                size='mini',
                                slot='reference'
                            ) {{ territorio.cars.length - 3 }}
                            .lista-scroll
                                div(
                                    v-for='(car, index) in territorio.cars',
                                    :key='index'
                                ) {{ car.codigo }} - {{ validaSituacao(car.condicao) }}

                .bloco-dados-territorio-interno--valor(
                    v-else-if='territorio.cars && territorio.cars.length === 0'
                )
                    span -

                .bloco-dados-territorio-interno--valor-cars(v-else)
                    span(v-for='(car, index) in territorio.cars', :key='index') {{ car.codigo }}
            .bloco-dados-territorio-interno--titulo Localidade:
                .bloco-dados-territorio-interno--valor
                    span {{ territorio.localidade }}
            .bloco-dados-territorio-interno--titulo Área em monitoramento
                .bloco-dados-territorio-interno--valor
                    span {{ getArea(territorio) }}
            .bloco-dados-territorio-interno--titulo Pessoas
                span(
                    v-if='territorio.representantes && territorio.representantes.length > 1'
                )
                    el-popover(placement='right', trigger='hover')
                        el-tag.ml-2(
                            v-if='territorio.representantes.length > 1',
                            size='mini',
                            slot='reference',
                            style='margin-top: 0px'
                        ) {{ territorio.representantes.length - 1 }}
                        .lista-scroll
                            div(
                                v-for='(representante, index) in territorio.representantes',
                                :key='index'
                            ) {{ representante.nomeRazaoSocial }}
                    .bloco-dados-territorio-interno--valor {{ monitoramento.territorio.representantes[0].nomeRazaoSocial }}

                .bloco-dados-territorio-interno--valor(
                    v-else-if='territorio.representantes && territorio.representantes.length === 0'
                )
                    span -

                .bloco-dados-territorio-interno--valor(v-else)
                    span(
                        v-for='(representante, index) in territorio.representantes',
                        :key='index'
                    ) {{ representante.nomeRazaoSocial }}
            .bloco-dados-territorio-interno--titulo(style='width: 35%') Data no início do monitoramento
                .bloco-dados-territorio-interno--valor
                    span {{ monitoramento.dataCadastroFormatado }}
            .bloco-dados-territorio-interno--titulo Usuário solicitante
                .bloco-dados-territorio-interno--valor
                    span {{ monitoramento.nomeUsuarioCriacao }}
        .bloco-dados-monitoramento__interno-texto(v-if='monitoramento.dataFim')
            .bloco-dados-territorio-interno--titulo Data do fim do monitoramento:
                .bloco-dados-territorio-interno--valor
                    span {{ monitoramento.dataFimFormatado }}
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'BlocoDadosTerritorioMonitoramentoSocioambiental',
    props: {
        territorio: {
            type: Object,
            required: true,
            default: null
        },
        monitoramento: {
            type: Object,
            required: true,
            default: null
        }
    },
    data() {
        return {};
    },
    methods: {
        formatarCar(codigo) {
            if (!codigo) return '-';
            return codigo.replace(codigo.substring(10, 39), '...');
        },
        getArea(territorio) {
            return `${formatters.formatNumber(territorio.areaHa, 2)} ha`;
        },
        validaSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return 'Ativo';
                case 'PE':
                    return 'Pendente';
                case 'SU':
                    return 'Suspenso';
                case 'CA':
                    return 'Cancelado';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.bloco-dados-territorio-monitoramento-socio-ambiental {
    height: 232px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    justify-content: flex-start;
    padding: 7px 15px;
    color: var(--primary);

    .bloco-dados-territorio-interno--titulo {
        padding-top: 0px;
        font-size: 14px;
        font-weight: 600;

        flex-wrap: wrap;
        padding-right: 5rem;
        margin-top: 7px;
        width: 30%;
    }

    .bloco-dados-territorio--interno {
        display: flex;
        flex-direction: row;

        .bloco-dados-territorio--interno--texto {
            flex-wrap: wrap;
            display: flex;
            flex-direction: row;
            min-height: 104px;
            margin-left: 12px;

            span {
                margin-top: 6px;
            }
        }
    }

    .bloco-dados-territorio-interno--valor {
        display: flex;
        padding-top: 1px;
        margin-bottom: 5%;
        max-width: 22rem;

        font-weight: 400;
        color: var(--primary);
        font-size: 12px;
    }

    .bloco-dados-territorio-interno--valor-cars{
        display: flex;
        padding-top: 1px;
        margin-bottom: 5%;
        max-width: 22rem;
        overflow: auto;
        font-weight: 400;
        color: var(--primary);
        font-size: 12px;
    }

    & p:first-child {
        margin: 4px 3px 8px 0px;
    }

    & p:not(:first-child) {
        margin: 2px 3px 8px 0px;
    }
}

.lista-scroll {
    max-height: 300px;
    overflow-y: auto;
    flex-direction: column;
    padding: 5px 10px;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: var(--text-disabled);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }
}

.el-popover__reference-wrapper {
    cursor: pointer;
}

@media only screen and (max-width: 1340px) {
    .bloco-dados-territorio {
        min-width: 48% !important;
    }
}
</style>
